import React, { useState, useEffect, useRef } from "react";
import { BACKEND, API_PERU_URL, API_PERU_TOKEN } from "../config/configEnvs";
import axios from "axios";
import {
  FaBuilding,
  FaCalendarAlt,
  FaChartLine,
  FaPercentage,
  FaPlus,
  FaSave,
  FaSearch,
  FaShoppingCart,
} from "react-icons/fa";
import Modal from "../components/ui/Modal";
import { toast } from "react-toastify";
import {
  FaCheck,
  FaRegBuilding,
  FaChevronLeft,
  FaFileInvoiceDollar,
  FaStore,
  FaBarcode,
  FaSpinner,
  FaMoneyBillWave,
  FaReceipt,
  FaChevronRight,
  FaBoxOpen,
  FaRegCalendarAlt,
  FaFilter,
} from "react-icons/fa";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import { FaTimes } from "react-icons/fa";
import FilterHeadersDialog from "../components/dialogs/FilterHeadersDialog";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FormLoader from "../components/ui/FormLoader";
import PaginationItem from "../components/ui/components/Pagination";
import ItemRowRegistroCompra from "../components/registroCompras/ItemRowRegistroCompra";
import InputFormValue from "../components/ui/components/InputFormValue";
import { getStartAndEndOfMonth } from "../utils/GetDates";
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import multiMonthPlugin from "@fullcalendar/multimonth";
import listPlugin from "@fullcalendar/list";
import Tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import { set } from "date-fns";
import { months, years } from "../utils/rawData/dateValues";
import { CategoriasCompras, SubcategoriasCompras } from "../utils/plainValues/ClasificacionCompras";
import Selector from "../components/ui/components/Selector";
import { OptionsEntidadPago, OptionsMoneda, OptionsTipoComprobante, OptionsTipoPago } from "../utils/rawData/comprasValues";


const RegistroCompras = () => {
  const [loadingStatus, setLoadingStatus] = useState(false);

  const [loading, setLoading] = useState(false);

  const [showPurchaseModal, setShowPurchaseModal] = useState(false);

  const [compras, setCompras] = useState([]);

  const [currentPayment, setCurrentPayment] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);

  const [validRUC, setValidRUC] = useState(false);
  const [isRucLoading, setIsRucLoading] = useState(false);
  const [ruc, setRuc] = useState(null);

  const [itemName, setItemName] = useState("");

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalPages, setTotalPages] = useState(0);
  const [totalDocs, setTotalDocs] = useState(1);

  const [openFilter, setOpenFilter] = useState(false);
  const [headersTableActive, setHeadersTableActive] = useState([]);

  const [categoria, setCategoria] = useState("");
  const [subcategoria, setSubcategoria] = useState("");

  const [archivo, setArchivo] = useState(null);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());

  const [startDateCalendar, setStartDateCalendar] = useState("");
  const [endDateCalendar, setEndDateCalendar] = useState("");

  const [cantidadTiempo, setCantidadTiempo] = useState(0)
  const [tipoPago, setTipoPago] = useState('Unico')

  const [vista, setVista] = useState("Tabla");
  const [events, setEvents] = useState([]);
  const [estadoPago, setEstadoPago] = useState("");

  const [tipoComprobante, setTipoComprobante] = useState("");
  const [tipoPagoFiltro, setTipoPagoFiltro] = useState("");
  const [monedaFiltro, setMonedaFiltro] = useState("");
  const [entidadFiltro, setEntidadFiltro] = useState("");

  useEffect(()=> {
    if (tipoPago === "Unico") {
      setCantidadTiempo(1)
    }
  }, [tipoPago])

  const [formValues, setFormValues] = useState({
    tipo_doc: "factura",
    fecha_pago: "",
    fecha_pago_real: "",
    nombre_item: "",
    numero_comprobante: "",
    ruc: "",
    razon_social: "",
    entidad: "",
    moneda: "soles",
    subtotal: 0,
    igv: 0,
    importe_total: 0,
    costo_unitario: 0,
    cantidad: 1,
    tipoPago: "Unico",
    cantidadTiempo: 1,
    tipoCosto: "Costo fijo",
    categoria: "Infraestructura Tecnológica.",
    subcategoria: "Hosting.",
  });

  const fetchCompras = async () => {
    try {
      setLoadingStatus(true);

      let url = `${BACKEND}/api/compras?page=${page}&limit=${limit}&sort=fecha_pago`;

      if (estadoPago) {
        url += `&where[estadoPago][equals]=${estadoPago}`;
      }
      if (month) {
        url += `&where[month][equals]=${month}`;
      }
      if (year) {
        url += `&where[year][equals]=${year}`;
      }
      if (itemName) {
        url += `&where[nombre_item][contains]=${itemName}`;
      }
      if (categoria) {
        url += `&where[categoria][equals]=${categoria}`;
      }
      if (subcategoria) {
        url += `&where[subcategoria][equals]=${subcategoria}`;
      }
      if (tipoComprobante) {
        url += `&where[tipo_doc][equals]=${tipoComprobante}`;
      }
      if (tipoPagoFiltro) {
        url += `&where[tipoPago][equals]=${tipoPagoFiltro}`;
      }
      if (monedaFiltro) {
        url += `&where[moneda][equals]=${monedaFiltro}`;
      }
      if (entidadFiltro) {
        url += `&where[entidad][equals]=${entidadFiltro}`;
      }

      const response = await axios.get(url, { withCredentials: true });

      setCompras(response.data.docs);
      setTotalDocs(response.data.totalDocs);
      setTotalPages(response.data.totalPages);

    } catch (error) {
      toast.error("No se pudieron cargar las compras: " + error);
      console.error("Error obteniendo compras:", error);
    } finally {
      setLoadingStatus(false);
    }
  };

  useEffect(() => {
    if (itemName === "") {
      fetchCompras();
    }
  }, [itemName]);

  const [allCompras, setAllCompras] = useState([]);

  const [totalDocsAllCompras, setTotalDocsAllCompras] = useState(0); // Compras realizadas
  const [subtotalSolesAllCompras, setSubtotalSolesAllCompras] = useState(0); // Subtotal en soles
  const [igvSolesAllCompras, setIgvSolesAllCompras] = useState(0); // IGV en soles
  const [totalSolesAllCompras, setTotalSolesAllCompras] = useState(0); // Total en soles
  const [totalDolaresAllCompras, setTotalDolaresAllCompras] = useState(0); // Total en dólares

  const fetchComprasForDataBar = async () => {
    try {

      let url = `${BACKEND}/api/compras?limit=0`;

      if (estadoPago) {
        url += `&where[estadoPago][equals]=${estadoPago}`;
      }
      if (month) {
        url += `&where[month][equals]=${month}`;
      }
      if (year) {
        url += `&where[year][equals]=${year}`;
      }
      if (itemName) {
        url += `&where[nombre_item][contains]=${itemName}`;
      }
      if (categoria) {
        url += `&where[categoria][equals]=${categoria}`;
      }
      if (subcategoria) {
        url += `&where[subcategoria][equals]=${subcategoria}`;
      }
      if (tipoComprobante) {
        url += `&where[tipo_doc][equals]=${tipoComprobante}`;
      }
      if (tipoPagoFiltro) {
        url += `&where[tipoPago][equals]=${tipoPagoFiltro}`;
      }
      if (monedaFiltro) {
        url += `&where[moneda][equals]=${monedaFiltro}`;
      }
      if (entidadFiltro) {
        url += `&where[entidad][equals]=${entidadFiltro}`;
      }

      const response = await axios.get(url, { withCredentials: true });

      setAllCompras(response.data.docs);
      setTotalDocsAllCompras(response.data.totalDocs);
      // Calcular totales por moneda
      const comprasSoles = response.data.docs.filter(compra => compra.moneda === 'soles');
      const comprasDolares = response.data.docs.filter(compra => compra.moneda === 'dolares');

      // Totales en soles
      setSubtotalSolesAllCompras(comprasSoles.reduce((acc, compra) => acc + compra.subtotal, 0));
      setIgvSolesAllCompras(comprasSoles.reduce((acc, compra) => acc + compra.igv, 0));
      setTotalSolesAllCompras(comprasSoles.reduce((acc, compra) => acc + compra.importe_total, 0));

      // Total en dólares
      setTotalDolaresAllCompras(comprasDolares.reduce((acc, compra) => acc + compra.importe_total, 0));

    } catch (error) {
      return false
    }
  };

  const fetchAllCompras = async () => {
    try {
      setLoadingStatus(true);
      let url = `${BACKEND}/api/compras?limit=0`
      let andFilters = [];

      if (startDateCalendar) {
        const adjustedStartDate = new Date(startDateCalendar);
        adjustedStartDate.setHours(adjustedStartDate.getHours() + 5);
        andFilters.push({
          createdAt: {
            greater_than_equal: adjustedStartDate?.toISOString(),
          }
        })
      }
      if (endDateCalendar) {
        const adjustedEndDate = new Date(endDateCalendar);
        adjustedEndDate.setHours(adjustedEndDate.getHours() + 29);
        andFilters.push({
          createdAt: {
            less_than_equal: adjustedEndDate?.toISOString(),
          }
        })
      }
      if (andFilters.length > 0) {
        andFilters.forEach((filter, index) => {
          const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
          const value = Object.values(Object.values(filter)[0])[0];
          url += `&${key}=${value}`;
        });
      }

      const response = await axios.get(url, { withCredentials: true })
      console.log(url)

      setCompras(response.data.docs);
    } catch (error) {
      toast.error("No se pudieron cargar las compras");
      console.error("Error obteniendo compras:", error);
    }
  }

  const resetData = () => {
    setValidRUC(false);
    setFormValues({
      tipo_doc: "factura",
      fecha_pago: "",
      fecha_pago_real: "",
      nombre_item: "",
      numero_comprobante: "",
      entidad: "",
      ruc: "",
      razon_social: "",
      moneda: "soles",
      subtotal: 0,
      igv: 0,
      importe_total: 0,
      costo_unitario: 0,
      cantidad: 1,
      tipoPago: "Unico",
      cantidadTiempo: 1,
      tipoCosto: "Costo fijo",
      estadoPago: "Pendiente",
      categoria: "Infraestructura Tecnológica.",
      subcategoria: "Hosting.",
    });
  };

  const openModalAdd = () => {
    setShowPurchaseModal(true);
  };

  const closeModalAdd = () => {
    setRuc(null);
    resetData();
    setShowPurchaseModal(false);
  };

  const handleImageUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(
        `${BACKEND}/api/comprasImagenes`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const mediaId = response.data.doc.id;
      return mediaId;
    } catch (error) {
      toast.error("Error al subir la imagen");
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      
      const filteredData = Object.fromEntries(
        Object.entries(formValues).filter(
          ([_, value]) => value !== null && value !== undefined && value !== ""
        )
      );

      // Calcular montos
      const subtotal = formValues.costo_unitario * formValues.cantidad;
      const igv = formValues.tipo_doc === "factura" ? subtotal * 0.18 : 0;
      const importe_total = subtotal + igv;

      // Si es pago único
      if (tipoPago === "Unico") {
        let fechaPagoISO = "";
        if (formValues.fecha_pago) {
          try {
            const date = new Date(formValues.fecha_pago + 'T00:00:00-05:00');
            if (!isNaN(date.getTime())) {
              fechaPagoISO = date.toISOString();
            }
          } catch (error) {
            console.error('Error procesando fecha:', error);
          }
        }

        await axios.post(`${BACKEND}/api/compras`, {
          ...filteredData,
          subtotal,
          igv,
          importe_total,
          tipoPago: "Unico",
          fecha_pago: fechaPagoISO,
          month: fechaPagoISO.split('-')[1],
          year: fechaPagoISO.split('-')[0]
        }, {withCredentials: true});
      } else {
        // Si es pago recurrente (todos los tipos)
        let diaPago, mesPago, añoPago;
        
        try {
          const date = new Date(formValues.fecha_pago + 'T00:00:00-05:00');
          if (!isNaN(date.getTime())) {
            diaPago = date.getDate();
            mesPago = date.getMonth();
            añoPago = date.getFullYear();
          } else {
            throw new Error('Fecha inválida');
          }
        } catch (error) {
          console.error('Error procesando fecha:', error);
          toast.error('La fecha seleccionada no es válida');
          return;
        }

        for (let i = 0; i < cantidadTiempo; i++) {
          let fechaPagoCalculada;
          
          switch (tipoPago) {
            case "Diario":
              fechaPagoCalculada = new Date(añoPago, mesPago, diaPago + i);
              break;
            case "Semanal":
              fechaPagoCalculada = new Date(añoPago, mesPago, diaPago + (i * 7));
              break;
            case "Quincenal":
              fechaPagoCalculada = new Date(añoPago, mesPago, diaPago + (i * 15));
              break;
            case "Mensual":
              fechaPagoCalculada = new Date(añoPago, mesPago + i, diaPago);
              break;
            case "Bimestral":
              fechaPagoCalculada = new Date(añoPago, mesPago + (i * 2), diaPago);
              break;
            case "Trimestral":
              fechaPagoCalculada = new Date(añoPago, mesPago + (i * 3), diaPago);
              break;
            case "Cuatrimestral":
              fechaPagoCalculada = new Date(añoPago, mesPago + (i * 4), diaPago);
              break;
            case "Semestral":
              fechaPagoCalculada = new Date(añoPago, mesPago + (i * 6), diaPago);
              break;
            case "Anual":
              fechaPagoCalculada = new Date(añoPago + i, mesPago, diaPago);
              break;
            default:
              fechaPagoCalculada = new Date(añoPago, mesPago + i, diaPago);
          }

          await axios.post(`${BACKEND}/api/compras?page=1`, {
            ...filteredData,
            fecha_pago: fechaPagoCalculada.toISOString(),
            subtotal,
            igv,
            importe_total,
            tipoPago,
            month: fechaPagoCalculada.getMonth() + 1,
            year: fechaPagoCalculada.getFullYear()
          }, {withCredentials: true});
        }
      }

      toast.success("Registro guardado exitosamente");
      
      closeModalAdd();
      fetchCompras();
      resetData();
      setRuc(null);
      setValidRUC(false);
    } catch (error) {
      console.error("Error al registrar la compra:", error);
      toast.error("Error al registrar la compra");
    } finally {
      setLoading(false);
    }
  };

  const handleSuccessChangeData = () => {
    fetchCompras();
  };

  const fetchRUC = async () => {
    if (validRUC) {
      toast.info("El RUC ya ha sido validado", { position: "top-right" });
      return;
    }
    if (!ruc || ruc === "") {
      toast.warning("Para validar el RUC primero completa el campo", {
        position: "top-right",
      });
      return;
    }
    if (ruc?.length !== 11) {
      toast.warning("RUC inválido", { position: "top-right" });
      return;
    }
    setIsRucLoading(true);
    try {
      const response = await axios.post(
        `${API_PERU_URL}ruc`,
        { ruc },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${API_PERU_TOKEN}`,
          },
        }
      );

      const payload = response.data?.data;
      if (!response.data?.success || !payload?.nombre_o_razon_social) {
        toast.warning("Este RUC no existe", { position: "top-right" });
        return;
      }

      setFormValues((prev) => ({
        ...prev,
        ruc,
        razon_social: payload.nombre_o_razon_social,
      }));
      toast.success("RUC validado", { position: "top-right" });
      setValidRUC(true);
    } catch (error) {
      toast.warning("Este RUC no existe", { position: "top-right" });
    } finally {
      setIsRucLoading(false);
    }
  };

  useEffect(()=> {
    fetchCompras();
  }, [page, limit, estadoPago, month, year, categoria, subcategoria, tipoComprobante, tipoPagoFiltro, monedaFiltro, entidadFiltro]);

  useEffect(()=> {
    fetchComprasForDataBar();
  }, [estadoPago, month, year, categoria, subcategoria, tipoComprobante, tipoPagoFiltro, monedaFiltro, entidadFiltro]);

  useEffect(() => {
    if (vista !== "Calendario") {
      setFormValues(prev => ({ ...prev, fecha_pago: "" }))
    }
  }, [vista]);

  useEffect(() => {
    if (vista === "Calendario" && compras.length > 0) {
      // Calcular totales por día
      const dailyTotals = {};
      
      // Sumar compras por día
      compras.forEach(p => {
        if (!p.fecha_pago) return;
        
        try {
          let date;
          if (p.fecha_pago.includes('T')) {
            date = new Date(p.fecha_pago);
          } else {
            const [year, month, day] = p.fecha_pago.split('-');
            date = new Date(year, month - 1, day);
          }
          
          if (isNaN(date.getTime())) return;
          
          const dateStr = date.toISOString().split('T')[0];
          if (!dailyTotals[dateStr]) {
            dailyTotals[dateStr] = { soles: 0, dolares: 0 };
          }
          
          if (p.moneda === "soles") {
            dailyTotals[dateStr].soles += p.importe_total;
          } else {
            dailyTotals[dateStr].dolares += p.importe_total;
          }
        } catch (error) {
          console.error('Error procesando fecha:', error);
        }
      });

      const mappedEvents = compras.map(p => {
        // Validar que la fecha exista y sea válida
        if (!p.fecha_pago) return null;
        
        try {
          // Verificar si la fecha ya está en formato ISO
          let date;
          if (p.fecha_pago.includes('T')) {
            // Si ya tiene formato ISO, usar directamente
            date = new Date(p.fecha_pago);
          } else {
            // Si no tiene formato ISO, asumir que es YYYY-MM-DD
            const [year, month, day] = p.fecha_pago.split('-');
            date = new Date(year, month - 1, day); // month - 1 porque los meses en JS son 0-based
          }

          if (isNaN(date.getTime())) {
            console.error('Fecha inválida:', p.fecha_pago);
            return null;
          }

          return {
            id: p.id,
            title: p.nombre_item,
            start: date.toISOString(),
            allDay: true,
            color: `${p.estadoPago === "Pendiente" ? "#ffd700" : "#4CAF50"}`,
            textColor: "#000000",
            order: 2,
            extendedProps: {
              tippyText: `${p.nombre_item} - ${p.importe_total.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })} ${p.moneda} - ${p.cantidad ? p.cantidad : 1} ítem(s)`,
              status: p.estadoPago,
              monto: p.importe_total.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }),
              items: p.cantidad ? p.cantidad : 1,
              moneda: p.moneda,
            }
          };
        } catch (error) {
          console.error('Error procesando fecha:', error, 'Fecha original:', p.fecha_pago);
          return null;
        }
      }).filter(event => event !== null); // Filtrar eventos nulos

      // Agregar eventos de totales diarios
      const totalEvents = [
        ...mappedEvents,
        ...Object.entries(dailyTotals).map(([date, totals]) => ({
          id: `total-${date}`,
          title: `Total del día: S/. ${totals.soles.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })} - $ ${totals.dolares.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}`,
          start: new Date(new Date(date).getTime() + (5 * 60 * 60 * 1000)).toISOString(),
          allDay: true,
          color: "#6B7280", // bg-gray-500
          textColor: "#FFFFFF",
          className: "text-xs font-bold",
          order: 1,
          extendedProps: {
            tippyText: `Total del día: S/. ${totals.soles.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} - $ ${totals.dolares.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}`,
            concept: "Total del día",
            amount: `${totals.soles.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} - $ ${totals.dolares.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}`,
            currency: "MIXED",
            status: "Total",
            color: "#6B7280"
          }
        }))
      ];

      console.log(totalEvents.length);

      setEvents(totalEvents);
    } else if (vista !== "Calendario") {
      setEvents([]); // Limpiar eventos si no hay compras
    }
  }, [vista, compras]);

  useEffect(() => {
    if (formValues.tipo_doc === "factura") {
      setFormValues((prevValues) => ({
        ...prevValues,
        igv: (formValues.cantidad * formValues.costo_unitario * 0.18).toFixed(2),
      }));
    } else {
      setFormValues((prevValues) => ({
        ...prevValues,
        igv: 0,
      }));
    }
  }, [formValues.tipo_doc, formValues.cantidad, formValues.costo_unitario]);

  // Headers
  const headers = [
    { id: 1, name: "Acciones", show: true },
    { id: 2, name: "Fecha emisión", show: true },
    { id: 3, name: "RUC", show: true },
    { id: 4, name: "Proveedor", show: true },
    { id: 5, name: "Descripción", show: true },
    { id: 6, name: "Tipo de comprobante", show: true },
    { id: 7, name: "N° comprobante", show: true },
    { id: 8, name: "Subtotal", show: true },
    { id: 9, name: "IGV", show: true },
    { id: 10, name: "Importe Total", show: true },
    { id: 11, name: "Comprobante de transacción", show: true },
    { id: 12, name: "Documentos de venta", show: true },
    { id: 13, name: "Estado de pago", show: true },
    { id: 14, name: "Fecha pago", show: true },
    { id: 15, name: "Tipo de pago", show: true },
    { id: 16, name: "Moneda", show: true },
    { id: 17, name: "Subcategoría", show: true },
    { id: 18, name: "Categoria", show: true },
    { id: 19, name: "Entidad de pago", show: true },
    { id: 20, name: "Costo unitario", show: true },
    { id: 21, name: "Cantidad de ítems", show: true },
    { id: 22, name: "Tipo de costo", show: true },
  ];

  useEffect(() => {
    if (headersTableActive.length > 0) {
      localStorage.setItem(
        "activeTableColsAfiliacionClientes",
        JSON.stringify(headersTableActive)
      );
    }
  }, [headersTableActive]);

  useEffect(() => {
    const localActiveHeaders =
      JSON.parse(localStorage.getItem("activeTableColsAfiliacionClientes1")) || [];
    if (localActiveHeaders.length > 0) {
      setHeadersTableActive(localActiveHeaders);
    } else {
      setHeadersTableActive(headers);
    }
  }, []);

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  /// Mobile
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 900px)");
    setIsMobile(mediaQuery.matches);
    const handleMediaQueryChange = (event) => {
      setIsMobile(event.matches);
    };
    mediaQuery.addEventListener("change", handleMediaQueryChange);
    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);

  // Categorías

  return (
    <div className="flex flex-col h-screen w-full">

      {/* Registrar nueva compra */}
      <Modal
        onClose={() => {setShowPurchaseModal(false)}}
        activeModal={showPurchaseModal}
        title="Registrar nueva compra"
        centered
        className="max-w-3xl"
      >
        <div className="flex flex-col md:flex-row gap-4 overflow-y-auto max-h-[75vh]">
          <div className="flex flex-col gap-4 w-full md:w-1/2">
            <InputFormValue
              required={true}
              title="Nombre del ítem o servicio"
              info="Chat GPT, Torta trabajador, etc."
              value={formValues.nombre_item}
              setValue={(value) => setFormValues(prev => ({ ...prev, nombre_item: value }))}
              icon={<FaBoxOpen />}
              placeholder="Nombre del ítem o servicio"
              type="text"
            />

            <InputFormValue
              required={true}
              title="Fecha de emisión"
              info="Fecha de emisión del comprobante de pago."
              value={formValues.fecha_pago}
              setValue={(value) => setFormValues(prev => ({ ...prev, fecha_pago: value }))}
              icon={<FaRegCalendarAlt />}
              placeholder="Fecha de emisión"
              type="date"
            />

            {/* <InputFormValue
              required={true}
              title="Fecha de pago"
              info="Fecha en la que se realizó el pago del ítem o servicio."
              value={formValues.fecha_pago_real}
              setValue={(value) => setFormValues(prev => ({ ...prev, fecha_pago_real: value }))}
              icon={<FaRegCalendarAlt />}
              placeholder="Fecha de pago"
              type="date"
            /> */}

            <InputFormValue
              required={true}
              title="Costo unitario del ítem o servicio."
              min={0}
              info="Costo por unidad del ítem o servicio."
              value={formValues.costo_unitario}
              setValue={(value) => setFormValues(prev => ({ ...prev, costo_unitario: value }))}
              icon={<FaMoneyBillWave />}
              placeholder="Costo unitario"
              type="number"
            />

            <InputFormValue
              required={true}
              title="Moneda"
              info="Moneda (soles, dolares)"
              value={formValues.moneda}
              setValue={(value) => setFormValues(prev => ({ ...prev, moneda: value }))}
              icon={<FaMoneyBillWave />}
              placeholder="Moneda"
              type="select"
              options={[
                { value: "soles", label: "Soles" },
                { value: "dolares", label: "Dolares" },
              ]}
            />

            <InputFormValue
              required={true}
              title="Cantidad de ítems"
              min={1}
              info="Cantidad de unidades o cuentas del ítem o servicio."
              value={formValues.cantidad}
              setValue={(value) => setFormValues(prev => ({ ...prev, cantidad: value }))}
              icon={<FaBoxOpen />}
              placeholder="Cantidad"
              type="number"
            />

            <InputFormValue
              required={true}
              title="Tipo de pago."
              info="El tipo de pago determina si el pago es único o recurrente."
              value={tipoPago}
              setValue={(value) => setTipoPago(value)}
              icon={<FaMoneyBillWave />}
              placeholder="Tipo de pago"
              type="select"
              options={OptionsTipoPago}
            />

            <InputFormValue
              required={true}
              title="Cantidad de tiempo."
              info="Cantidad de tiempo (meses o años) por la que se realizará el pago recurrente."
              value={cantidadTiempo}
              setValue={(value) => setCantidadTiempo(value)}
              icon={<FaCalendarAlt />}
              placeholder="Cantidad de tiempo"
              min={1}
              type="number"
            />

            <InputFormValue
              title="Tipo de costo"
              info="El tipo de costo determina si el costo es variable o fijo, si el monto muta cada mes o año."
              value={formValues.tipoCosto}
              setValue={(value) => setFormValues(prev => ({ ...prev, tipoCosto: value }))}
              icon={<FaMoneyBillWave />}
              placeholder="Tipo de costo"
              type="select"
              options={[
                { value: "Costo fijo", label: "Costo fijo" },
                { value: "Costo variable", label: "Costo variable" },
              ]}
            />
  
          </div>

          <div className="flex flex-col gap-4 w-full md:w-1/2">     

            <InputFormValue
              title="Categoría"
              info="Categoría del ítem o servicio."
              value={formValues.categoria}
              setValue={(value) => setFormValues(prev => ({ ...prev, categoria: value }))}
              icon={<FaMoneyBillWave />}
              placeholder="Categoría"
              type="select"
              options={CategoriasCompras}
              required={true}
            />

            <InputFormValue
              title="Subcategoría"
              info="Subcategoría del ítem o servicio."
              value={formValues.subcategoria}
              setValue={(value) => setFormValues(prev => ({ ...prev, subcategoria: value }))}
              icon={<FaMoneyBillWave />}
              placeholder="Subcategoría"
              type="select"
              options={SubcategoriasCompras.filter(e => e.category === formValues.categoria)}
              required={true}
            />


            <InputFormValue
              title="Número de comprobante"
              info="Número del comprobante de pago en caso se requiera."
              value={formValues.numero_comprobante}
              setValue={(value) => setFormValues(prev => ({ ...prev, numero_comprobante: value }))}
              icon={<FaBarcode />}
              placeholder="Número de comprobante de pago"
              type="text"
            />

            <div className="flex flex-col gap-1">
              <label className="flex flex-row items-center text-xs block text-gray-700">
                RUC
              </label>
              <div className="flex">
                <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                  <FaRegBuilding className="w-4 h-4 text-gray-500 " />
                </span>
                <input
                  type="text"
                  id="ruc"
                  value={ruc}
                  disabled={validRUC}
                  onChange={(e) => setRuc(e.target.value)}
                  className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  "
                  placeholder="RUC"
                />

                {validRUC ? (
                  <>
                    <div className="text-xs inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border rounded-e-0 border-gray-300 border-e-0 rounded-e-0">
                      Validado
                      <FaCheck className="text-white" />
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        setValidRUC(false);
                        setRuc("");
                        setFormValues({
                          ...formValues,
                          ruc: "",
                          razon_social: "",
                        });
                      }}
                      className="text-xs inline-flex items-center px-2 py-1 text-xs text-gray-900 bg-red-200 border rounded-e-md border-gray-300 hover:bg-red-300"
                    >
                      <FaTimes className="w-4 h-4 text-red-500" />
                      <span className="sr-only text-xs">Eliminar validación</span>
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    disabled={isRucLoading}
                    onClick={fetchRUC}
                    className="text-xs inline-flex gap-2 items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-e-md "
                  >
                    {isRucLoading ? (
                      <FormLoader colour={"#F64000"} className={" w-4"} />
                    ) : (
                      <>
                        Validar
                        <FaCheck />
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>

            <InputFormValue
              title="Nombre del proveedor"
              info="Nombre del proveedor del ítem o servicio."
              value={formValues.razon_social}
              setValue={(value) => setFormValues(prev => ({ ...prev, razon_social: value }))}
              icon={<FaStore />}
              placeholder="Nombre del proveedor"
              type="text"
            />

            <InputFormValue
              required={true}
              title="Tipo de documento"
              info="Tipo de documento (factura, boleta, recibo)."
              value={formValues.tipo_doc}
              setValue={(value) => setFormValues(prev => ({ ...prev, tipo_doc: value }))}
              icon={<FaReceipt />}
              placeholder="Tipo de documento"
              type="select"
              options={OptionsTipoComprobante}
            />

            <InputFormValue
              required={true}
              title="Subtotal"
              info="Subtotal del ítem o servicio."
              value={formValues.cantidad * formValues.costo_unitario}
              icon={<FaMoneyBillWave />}
              placeholder="Subtotal"
              type="number"
              disabled={true}
            />

            <InputFormValue
              title="IGV por pago"
              info="IGV del ítem o servicio."
              value={
                formValues.tipo_doc === "factura"
                  ? (formValues.cantidad * formValues.costo_unitario * 0.18).toFixed(2)
                  : "No aplica"
              }
              className={`text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5`}
              setValue={(value) => setFormValues(prev => ({ ...prev, igv: value }))}
              icon={<FaPercentage />}
              placeholder="IGV"
              type="number"
            />
          </div>
        </div>

        {formValues.moneda && tipoPago && cantidadTiempo && formValues.fecha_pago && (
          <span className="text-xs text-gray-500">
            {tipoPago === "Unico" 
              ? `Se generará un pago único de ${formValues.costo_unitario * formValues.cantidad} ${formValues.moneda}`
              : tipoPago === "Mensual" 
                ? `Se generará un pago de ${formValues.costo_unitario * formValues.cantidad} ${formValues.moneda} los ${new Date(formValues.fecha_pago).getDate()} de cada mes por ${cantidadTiempo} meses`
                : `Se generará un pago de ${formValues.costo_unitario * formValues.cantidad} ${formValues.moneda} los ${new Date(formValues.fecha_pago).getDate()} de ${new Date(formValues.fecha_pago).toLocaleString('es-ES', { month: 'long' })} de cada año por ${cantidadTiempo} años`
            }
          </span>
        )}

        <div className="flex w-full items-center justify-center gap-4 mt-4">
          <button
            type="button"
            onClick={closeModalAdd}
            className="text-xs bg-gray-600 text-white rounded-lg px-4 py-2 w-1/2 font-bold flex justify-center items-center gap-2"
          >
            <FaTimes />
            Cancelar
          </button>
          <button
            onClick={handleSubmit}
            className="text-xs bg-orange-500 text-white rounded-lg px-4 py-2 w-1/2 font-bold flex justify-center items-center gap-2"
          >
            <FaSave />
            Generar pago(s)
          </button>
        </div>
      </Modal>

      <FilterHeadersDialog
        open={openFilter}
        setOpen={setOpenFilter}
        activeCols={headersTableActive}
        setActiveCols={setHeadersTableActive}
      />

      {/* Header */}
      <div className="flex flex-row py-2 bg-gray-100">
        <div className="flex px-4 wflex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex items-center gap-4 p-4">
            <FaShoppingCart className="text-2xl text-gray-700" />
            <h2 className="text-2xl font-bold text-gray-700">
              Registro de compras
            </h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Vista:</span>
              <select
                value={vista}
                onChange={(e) => setVista(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="Tabla">Tabla</option>
                <option value="Calendario">Calendario</option>
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <div className="flex flex-row gap-4 items-center justify-center">
                <span className="text-xs">
                  Buscar:
                </span>
                <div className="flex items-start h-full max-w-sm mx-auto">
                  <div className="relative w-full">
                    <input
                      type="text"
                      placeholder={`Buscar ítem o servicio`}
                      className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                      value={itemName}
                      onChange={(e) => setItemName(e.target.value)}
                    />
                    {itemName && (
                      <FaTimes
                        onClick={() => setItemName("")}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                      />
                    )}
                  </div>
                  <button
                    onClick={() => fetchCompras()}
                    className="p-2 ms-2 text-xs font-medium text-white bg-blue-700 rounded-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    <FaSearch className="w-3 h-3" />
                    <span className="sr-only">Search</span>
                  </button>
                </div>
              </div>
            </div>

            <div>
              <Button
                variant="contained"
                onClick={openModalAdd}
                endIcon={<AddIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  whiteSpace: "nowrap",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#bb4a03",
                  },
                }}
              >
                Nueva compra
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Metadata */}
      <div className="flex bg-gray-100 mt-0.5 w-full py-1">
        <div className="w-full items-center overflow-x-auto px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row justify-center items-center">
            <div className="flex items-center text-xs">
              <span className="border-r border-gray-300 pr-4 pl-4">
                <span className="font-medium">Compras realizadas: </span>{totalDocsAllCompras}
              </span>
              <span className="border-r border-gray-300 pr-4 pl-4">
                <span className="font-medium">Subtotal S/: </span>{subtotalSolesAllCompras.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </span>
              <span className="border-r border-gray-300 pr-4 pl-4">
                <span className="font-medium">IGV S/: </span>{igvSolesAllCompras.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </span>
              <span className="border-r border-gray-300 pr-4 pl-4">
                <span className="font-medium">Total S/: </span>{totalSolesAllCompras.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </span>
              <span className="pl-4 font-medium">
                <span className="font-medium">Total $: </span>{totalDolaresAllCompras.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Body */}
      {vista === "Tabla" ? (
        <>
        
          {/* Barra de filtros */}
          <div className="flex bg-gray-100 mt-0.5 mb-0.5 justify-between gap-10">
            <div className="flex flex-row w-full items-center justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
              <div className="flex flex-row gap-4 items-center justify-center">

                <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
                  <span>Categoría</span>
                  <select
                    value={categoria}
                    onChange={(e) => {
                      setCategoria(e.target.value)
                      setSubcategoria("")
                    }}
                    className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                  >
                    <option value="">Todos</option>
                    {CategoriasCompras.map((c) => (
                      <option key={c.value} value={c.value}>
                        {c.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
                  <span>Subcategoría</span>
                  <select
                    value={subcategoria}
                    onChange={(e) => setSubcategoria(e.target.value)}
                    className="text-gray-700 w-[300px] hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                  >
                    <option value="">Todos</option>
                    {SubcategoriasCompras.filter((c) => c.category === categoria).map((s) => (
                      <option key={s.value} value={s.value}>
                        {s.value}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
                  <span>Estado:</span>
                  <select
                    value={estadoPago}
                    onChange={(e) => setEstadoPago(e.target.value)}
                    className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                  >
                    <option value="">Todos</option>
                    <option value="Pendiente">Pendiente</option>
                    <option value="Pagado">Pagado</option>
                  </select>
                </div>

                <div className="flex flec-row items-center justify-center gap-2">
                  <label className="block text-xs font-medium text-gray-900">
                    Mes
                  </label>

                  <div className="flex flex-row items-center justify-center gap-4">
                    <select 
                      className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                      value={month}
                      onChange={(e) => setMonth(e.target.value)}
                    >
                      <option value="">Todos</option>
                      {months.map((month) => (
                        <option key={month.value} value={month.value}>
                          {month.label}
                        </option>
                      ))}
                    </select>
                  </div> 
                </div>

                <div className="flex flec-row items-center justify-center gap-2">
                  <label className="block text-xs font-medium text-gray-900">
                    Año
                  </label>

                  <div className="flex flex-row items-center justify-center gap-4">
                    <select 
                      className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                    >
                      <option value="">Todos</option>
                      {years.map((year) => (
                        <option key={year.value} value={year.value}>
                          {year.label}
                        </option>
                      ))}
                    </select>
                  </div> 
                </div>
              </div>
              <div className="flex items-center mx-4">
                <div className="flex items-center">
                  <button
                    className="text-orange-600 bg-orange-500 bg-opacity-10 hover:bg-opacity-20 rounded-md p-1.5"
                    type="button"
                    onClick={() => setOpenFilter(true)}
                  >
                    <FaFilter className="text-xs"/>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Barra de filtros 2*/}
          <div className="flex bg-gray-100 mt-0.5 mb-0.5 justify-between gap-10">
            <div className="flex flex-row w-full items-center justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
              <div className="flex flex-row gap-4 w-full items-center justify-center">

                <Selector
                  title="Tipo de comprobante"
                  value={tipoComprobante}
                  options={[ {value: "", label: "Todos"}, ...OptionsTipoComprobante]}
                  setter={setTipoComprobante}
                  defaultValue=""
                  defaultText="Todos"
                />

                <Selector
                  title="Tipo de pago"
                  value={tipoPagoFiltro}
                  options={[ {value: "", label: "Todos"}, ...OptionsTipoPago]}
                  setter={setTipoPagoFiltro}
                  defaultValue=""
                  defaultText="Todos"
                />

                <Selector
                  title="Moneda"
                  value={monedaFiltro}
                  options={[ {value: "", label: "Todos"}, ...OptionsMoneda]}
                  setter={setMonedaFiltro}
                  defaultValue=""
                  defaultText="Todos"
                />

                <Selector
                  title="Entidad de pago"
                  value={entidadFiltro}
                  options={[ {value: "", label: "Todos"}, ...OptionsEntidadPago]}
                  setter={setEntidadFiltro}
                  defaultValue=""
                  defaultText="Todos"
                />

              </div>
            </div>
          </div>

          {/* Body */}
          <div className="flex-grow overflow-y-auto">
            {loadingStatus ? (
                <LoadingScreen />
              ) : (
                compras.length == 0 ? (
                  <NoDataScreen />
                ) : (
                  <table className="w-full">
                    <thead className="bg-white sticky top-0">
                      <tr className="text-gray-700 text-center text-[10px] font-bold">

                        {headersTableActive.map((e, i) => {
                          return (
                            e.show && (
                              <th key={i} className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                                {e.name}
                              </th>
                            )
                          )
                        })}

                      </tr>
                    </thead>
                    <tbody>
                      {compras.map((compra) => (
                        <ItemRowRegistroCompra
                          key={compra.id}
                          compra={compra}
                          activeCols={headersTableActive}
                          handleSuccessChangeData={handleSuccessChangeData}
                        />
                      ))}
                    </tbody>
                  </table>
                )
              )
            }
          </div>

          <PaginationItem 
            actualDocs={compras.length}
            totalDocs={totalDocs}
            entity={"compras"}
            totalPages={totalPages}
            actualPage={page}
            handlePageChange={handlePageChange}
          />
        </>
      ) : (
        <div className="flex w-full gap-2 mt-4">
          <div className="px-4 flex-1">
            <FullCalendar
              events={events}
              eventOrder={"order,start,-duration,title"}
              height="75vh"
              selectable={true}
              dateClick={(info) => {
                openModalAdd();
                setFormValues(prev => ({ ...prev, fecha_pago: info.date.toISOString().split('T')[0] }))
              }}
              datesSet={(e) => {
                const currentDate = new Date(e.view.currentStart);
                const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
                const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
                
                setStartDate(firstDayOfMonth.toISOString().split('T')[0]);
                setEndDate(lastDayOfMonth.toISOString().split('T')[0]);
                setMonth(currentDate.getMonth() + 1);
                setYear(currentDate.getFullYear());
              }}
              plugins={[
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                listPlugin,
                multiMonthPlugin,
              ]}
              moreLinkText={"Ver todos"}
              locale={"es"}
              headerToolbar={{
                start: "title",
                //center: "multiMonthYear,dayGridMonth",
                end: "prev,next",
              }}
              buttonText={{
                today: "Hoy",
                month: "Mes",
                year: "Año",
                week: "Semana",
                day: "Día",
                listMonth: "Vista mes",
                listDay: "Vista hoy",
                timeGrid: "Semana",
              }}
              views={{
                timeGridFourDay: {
                  type: "timeGrid",
                  duration: { days: 4 },
                  buttonText: "Semana",
              },
                timeGridWeek: {
                  duration: { days: isMobile ? 4 : 7 },
                  buttonText: "Semana",
                },
              }}
              initialView={"dayGridMonth"}
              moreLinkHint={true}
              defaultAllDay
              eventContent={function (arg) {

                let containerEl = document.createElement("div");
                containerEl.classList = `event-container cursor-pointer transition-all duration-100 hover:bg-gray-100`;

                let contentEl = document.createElement("p");
                contentEl.classList = "event-content overflow-hidden";

                if (arg.event.extendedProps.isUrgent) {
                  contentEl.innerHTML = "urgent event";
                } else {
                  contentEl.innerHTML = `${arg.event.title}`;
                }

                containerEl.appendChild(contentEl);

                // Add click event listener
                containerEl.addEventListener("click", async function (event) {
                  // Check if the clicked element matches the desired element
                  if (event.target.classList.contains("event-content")) {
                    setCurrentPayment(compras.find(p => p.id === arg.event.id))
                    setOpenDrawer(true)
                  }
                });

                return { domNodes: [containerEl] };
              }}
              eventDidMount={(info) => {
                Tippy(info.el, {
                  content: `${info.event.extendedProps.tippyText}`,
                  placement: 'top',
                  theme: 'dark',
                  animation: 'scale'
                });
              }}
              initialEvents={[]}
            />
          </div>
        </div>
      )}

    </div>
  );
};

export default RegistroCompras;
